// extracted by mini-css-extract-plugin
export default {"wrapper":"Spinner_wrapper__p2dcv","spinner":"Spinner_spinner__HEmqZ","spin":"Spinner_spin__oZ+Vx"};